export default __webpack_public_path__ + "static/media/ripples.5329e7bd.png";